import React, { useState, Fragment } from "react"

import { Input, Row, Col, Button, FormFeedback, Form, FormGroup } from "src/ui"

import { sendHubspotForm } from "./utils"

const isValidEmail = (email: string) =>
  /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)

export const NewsletterSignup: React.FC = () => {
  const [email, setEmail] = useState("")
  const [canSubmit, setCanSubmit] = useState(true)
  const [submitMessage, setSubmitMessage] = useState<string | null>(null)
  const [submitMessageType, setSubmitMessageType] = useState<
    "success" | "error" | null
  >(null)

  const resetForm = () => {
    setEmail("")
    setCanSubmit(true)
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setCanSubmit(false)
    setSubmitMessage(null)
    if (email && isValidEmail(email)) {
      sendHubspotForm({ email }).then(res => {
        if (res.status === "success") {
          resetForm()
          setSubmitMessage(res.message)
          setSubmitMessageType("success")
        } else {
          setCanSubmit(true)
          setSubmitMessage(res.message)
          setSubmitMessageType("error")
        }
      })
    }
  }

  return (
    <Row className="justify-content-center">
      <Col md="8" lg="6">
        <Form inline className="justify-content-center" onSubmit={handleSubmit}>
          {submitMessage && submitMessageType === "success" ? null : (
            <Fragment>
              <FormGroup>
                <Input
                  bsSize="lg"
                  placeholder="Your email"
                  type="email"
                  value={email}
                  onChange={({ target: { value } }) => setEmail(value)}
                  required
                />
              </FormGroup>
              <Button
                color="primary"
                size="lg"
                type="submit"
                disabled={!canSubmit}
              >
                SIGN UP
              </Button>
            </Fragment>
          )}
        </Form>

        {submitMessage && submitMessageType && (
          <Row>
            <Col>
              <FormFeedback
                valid={submitMessageType === "success"}
                className="d-block"
                dangerouslySetInnerHTML={{ __html: submitMessage }}
              />
            </Col>
          </Row>
        )}
      </Col>
    </Row>
  )
}
